function postForm(url, value) {
  const form = document.createElement("form");
  form.method = "POST";
  form.action = url;
  for (const key of Object.keys(value)) {
    const inputElement = document.createElement("input");
    inputElement.type = "hidden"; //入力フォームが表示されないように
    inputElement.name = key;
    inputElement.value = value[key];
    form.appendChild(inputElement);
  }
  document.body.appendChild(form);
  form.submit();
}


import { TYPE_PC, TYPE_SP } from "../../common/defines";
import masterData from "../../lib/masterData";

const urlRoot = '';

export function applyRoom(room, asset, type, contractType, startDate, campaignId, rakuraku, rakurakuJou, packing, cardboard, cardboardM, cardboardL, felicaCardFlg, felicaCardCount, warrantyFlg, rackService, rackSmall, rackMedium, rackBig, rackHanger, caster, storageCase, storageboxSmall, storageboxMedium) {
  const pref = masterData.pref.byId[asset.pref];
  const prefSlug = pref.slug;
  if (type === TYPE_PC) {
    postForm(
      urlRoot + "/hello-storage/detail3/new_apply_login.html",
      {
        select_dev_mng_no: room.roomId,
        dev_mng_no: room.roomId,
        bukken_no: asset.assetId,
        jou: room.extent,
        contract_form_cd: contractType,
        riyou_kikan_start: startDate,
        campaign_cd: campaignId,
        option_rakuraku_flg: (rakuraku == null || rakuraku == 0 ? "0" : "1"),
        option_rakuraku_jou: rakurakuJou,
        option_packing_flg: (packing == null || packing == 0 ? "0" : "1"),
        option_cardboard_flg: (cardboard == null || cardboard == 0 ? "0" : "1"),
        option_cardboard_m: cardboardM,
        option_cardboard_l: cardboardL,
        felica_card_flg: (felicaCardFlg == null || felicaCardFlg == 0 ? "0" : "1"),
        felica_card_count: felicaCardCount,
        warranty_flg: warrantyFlg,
        option_rack_flg: (rackService == null || rackService == 0 ? "0" : "1"),
        option_rack_small: rackSmall,
        option_rack_medium: rackMedium, 
        option_rack_big: rackBig,
        option_rack_hanger: rackHanger,
        option_caster: caster,
        option_storage_case: storageCase,
        option_storagebox_small: storageboxSmall,
        option_storagebox_medium: storageboxMedium,
      }
    );
  } else {
    if (campaignId == null) {
      campaignId = "00";
    }
    rakuraku = (rakuraku == null || rakuraku == 0 ? "0" : "1");
    packing = (packing == null || packing == 0 ? "0" : "1");
    cardboard = (cardboard == null || cardboard == 0 ? "0" : "1");
    felicaCardFlg = (felicaCardFlg == null || felicaCardFlg == 0 ? "0" : "1");
    rackService = (rackService == null || rackService == 0 ? "0" : "1");
    const url = urlRoot + `/hello-storage_sp/${prefSlug}/apply2/${asset.assetId}/${room.roomId}/${contractType}/${startDate}/${campaignId}/${rakuraku}_${rakurakuJou}_${packing}_${cardboard}_${cardboardM}_${cardboardL}_${felicaCardFlg}_${felicaCardCount}_${warrantyFlg}_${rackService}_${rackSmall}_${rackMedium}_${rackBig}_${rackHanger}_${caster}_${storageCase}_${storageboxSmall}_${storageboxMedium}/new_login.html`;
    location.href = url;
  }
}

export function contactForRoom({ asset, params }) {
  const searchParams = new URLSearchParams();
  const queryParams = Object.assign({
    object_cd: asset && asset.assetId,
  }, params);
  for (const key of Object.keys(queryParams)) {
    if (queryParams[key] != null) {
      searchParams.append(key, queryParams[key]);
    }
  }
  const url =
    "/hello-storage/contact/?" + searchParams;
  window.open(url, "_blank");
}



// WEBPACK FOOTER //
// ./pages/area/util.js